import React from 'react';
import StoryletRoot from 'components/StoryletRoot';
import AddContact from './components/AddContact';

import InvitationForm from './components/InvitationForm';
import QualityRequirements from './components/QualityRequirements';
import SelectContact from './components/SelectContact';
import { IStorylet } from 'types/storylet';

export default function ActComponent(props: Props) {
  const {
    branch,
    eligibleFriends,
    ineligibleContacts,
    onAddContact,
    onSelectContact,
    rootEventId,
    selectedContactId,
  } = props;

  return (
    <div className="act">
      <StoryletRoot data={branch} rootEventId={rootEventId} />
      <h2 className="heading heading--2">Invite a contact</h2>
      <QualityRequirements />
      <div className="act__contact-choice-methods">
        <SelectContact
          eligibleFriends={eligibleFriends}
          ineligibleContacts={ineligibleContacts}
          onSelectContact={onSelectContact}
          selectedContactId={selectedContactId}
        />
        <AddContact onAddContact={onAddContact} />
      </div>

      <InvitationForm
        eligibleFriends={eligibleFriends}
        selectedContactId={selectedContactId}
      />
    </div>
  );
}

interface Props {
  branch: IStorylet,
  eligibleFriends: any[],
  ineligibleContacts: any[],
  onAddContact: Function,
  onSelectContact: (...args: any[]) => any,
  rootEventId: number,
  selectedContactId?: number,
}

/*
ActComponent.propTypes = {
  branch: BranchPropTypes.branch.isRequired,
  eligibleFriends: PropTypes.arrayOf(ActPropTypes.eligibleFriend).isRequired,
  ineligibleContacts: PropTypes.arrayOf(ActPropTypes.ineligibleContact).isRequired,
  onAddContact: PropTypes.func.isRequired,
  onSelectContact: PropTypes.func.isRequired,
  rootEventId: PropTypes.number.isRequired,
  selectedContactId: PropTypes.number,
};

ActComponent.defaultProps = {
  selectedContactId: undefined,
};
 */